<template>
  <div class="rc-table rc-table-border">
    <div class="rc-table__hidden-columns">
      <slot/>
    </div>
    <table class="rc-table__table rc-table-border__table" border="0" cellspacing="0" cellpadding="0">
      <table-colgroup/>
      <table-header/>
      <table-body/>
    </table>
  </div>
</template>
<script type="text/ecmascript-6">
import TableColgroup from './TableColgroup'
import TableHeader from './TableHeader'
import TableBody from './TableBody'
let tableTitleIdSeed = 1
export default {
  name: 'RcTable', // 简易table组件
  components: {
    TableHeader, TableBody, TableColgroup
  },
  props: {
    border: Boolean,
    striped: Boolean,
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      titleColumns: []
    }
  },
  computed: {
    tableData() {
      return this.data
    },
    columns() {
      return this.titleColumns;
    }
  },
  created() {
    this.tableIdSeed = `table-title_${tableTitleIdSeed++}`
    this.titleColumns = this.$slots.default.filter(column => {
      return !!column.tag
    })
  }
}
</script>
<style rel="stylesheet/css" type="text/css" lang="scss">
@include b(table) {
  @include e(hidden-columns) {
    visibility: hidden;
    position: absolute;
    z-index: -1;
  }

  @include e(table) {
    width: 100%;
    border-collapse: collapse;
  }

  @include e(cell) {
    padding: 5px 2px;
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
  }

  @include e(empty) {
    line-height: 20px;
    padding: 10px;
    font-size: 14px;
  }

  th,
  td {
    text-align: left;

    @include when(center) {
      text-align: center;
    }
  }
}

@include b(table-border) {
  @include e(table) {
    border: 1px solid #e6e6e9;
    border-right: none;
    border-bottom: none;
  }

  th,
  td {
    border: 1px solid #e6e6e9;
    border-left: none;
    border-top: none;
  }
}
</style>
